import {ImageBackground, Pressable, ScrollView, Text, View} from "react-native";
import React from "react";
import {createNativeStackNavigator} from "@react-navigation/native-stack";

import {styles, TAB_BAR_HEIGHT} from "../common/styles";
import {WhiteViewHeader} from "../common/WhiteViewHeader";
import TriangleIcon from "../icons/TriangeIcon";
import {i18n} from "../common/localization";
import {Reservation, reservationType} from "./Reservation";

import bg from "../assets/gym-sauna-bg.png";
import gymButton from "../assets/gym-button.jpg";
import saunaButton from "../assets/sauna-button.jpg";

const Stack = createNativeStackNavigator();

export const GymSauna = () => {
    return (
        <Stack.Navigator>
            <Stack.Screen
                name="Home"
                component={GymSaunaHome}
                options={{ headerShown: false }}
            />
            <Stack.Screen
                name="SaunaReservation"
                options={{ headerShown: false }}
            >
                {(props) => <Reservation {...props} type={reservationType.SAUNA} />}
            </Stack.Screen>
            <Stack.Screen
                name="GymReservation"
                options={{ headerShown: false }}
            >
                {(props) => <Reservation {...props} type={reservationType.GYM} />}
            </Stack.Screen>
        </Stack.Navigator>
    )
}

export const GymSaunaHome = ({ navigation }) => {
    function onPressSauna() {
        navigation.navigate('SaunaReservation');
    }

    function onPressGym() {
        navigation.navigate('GymReservation');
    }

    return (
        <View style={styles.container}>
            <ImageBackground source={bg} resizeMode="contain" style={{...styles.whiteViewBgImageContainer, width: "100%", height: 118}} />
            <View style={{...styles.whiteViewContainer, paddingBottom: TAB_BAR_HEIGHT}}>
                <WhiteViewHeader/>
                <ScrollView style={styles.whiteViewScrollView}>
                    <Text style={styles.whiteViewTitleText}>{i18n.t("gymSaunaTitle")}</Text>
                    <View style={styles.whiteViewScrollViewInnerContainer}>
                        <ImageBackground source={gymButton} resizeMode="cover" style={styles.gym.tileButton} >
                            <Pressable onPress={onPressGym} style={styles.gym.tileButtonContainer}>
                                <Text style={styles.gym.tileButtonTitle}>{i18n.t("gym")}</Text>
                                <Text style={styles.gym.tileButtonText}>{i18n.t("reservation")}</Text>
                            </Pressable>
                        </ImageBackground>
                        <TriangleIcon color="#39A3FF" style={styles.colorTriangle} />
                    </View>
                    <View style={styles.whiteViewScrollViewInnerContainer}>
                        <ImageBackground source={saunaButton} resizeMode="cover" style={styles.gym.tileButton} >
                            <Pressable onPress={onPressSauna} style={styles.gym.tileButtonContainer}>
                                <Text style={styles.gym.tileButtonTitle}>{i18n.t("sauna")}</Text>
                                <Text style={styles.gym.tileButtonText}>{i18n.t("reservation")}</Text>
                            </Pressable>
                        </ImageBackground>
                        <TriangleIcon color="#FFDF39" style={styles.colorTriangle} />
                    </View>
                </ScrollView>
            </View>
        </View>
    )
}
